<div class="container-fluid" id="body">
    <div class="row">
        <div class="col-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-9">
                    <h5 class=""><i class="fa fa-building"></i><b> My Account :</b> Consultant Management </h5>
                </div>
                <div class="col-3 text-right">
                    <strong class="text-right" style="color:rgb(253, 207,76 );">{{user?.UserName}}</strong>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="control-label hd-cat">
          <strong>Carrier Name:</strong> {{carrier_name}}
        </label>
                </div>
            </div>
            <br>
            <hr>
            <fieldset class="card border-light shadow-sm" style="margin:0px;padding:0px;">
                <style>
                    table {
                        border-collapse: separate;
                        border-spacing: 0 15px;
                    }
                    
                    th {
                        background-color: white;
                        color: black;
                    }
                    
                    th,
                    td {
                        width: 150px;
                        border: 2px solid white;
                        padding: 5px;
                    }
                </style>
                <label class="control-label hd-cat">
          <strong>Linking Option</strong>
        </label>
                <div class="row" style="margin:4px auto!important;padding:0px;font-size:11px!important;">
                    <div class=" col-12 table-responsive-sm" style="width:100%!important;margin:0px;padding:0px;">
                        <table class="" style="width:100%!important;margin:0px;padding:30px;" border="0">
                            <tr>
                                <th>
                                    <div>
                                        <h6>link user :</h6>
                                    </div>
                                </th>

                                <th>
                                    <div><input type="text" style="margin:0px;padding:0px; padding-left: 8px;" [(ngModel)]="user_email" name="user_email" class="form-control form-control-sm" placeholder="Enter email" /></div>
                                </th>
                                <th style="text-align: center;">
                                    <div>
                                        <h6> Or </h6>
                                    </div>
                                </th>
                                <th>
                                    <div>
                                        <h6>link user :</h6>
                                    </div>
                                </th>

                                <th>
                                    <div><input type="text" style="margin:0px;padding:0px; padding-left: 8px;" [(ngModel)]="username" name="username" class="form-control form-control-sm" placeholder="Enter username" /></div>
                                </th>

                                <!--Button with tooltip and no label -->
                                <th>
                                    <div><button class="btn link-btn" title="Link Selected User" (click)="linkUser()"></button></div>
                                </th>
                            </tr>


                        </table>
                    </div>
                </div>
            </fieldset>


            <fieldset class="card border-light shadow-sm" style="margin:0px;padding:0px;">
                <label class="control-label hd-cat">
          <strong>Filters</strong>
        </label>
                <div class="row" style="margin:4px auto!important;padding:0px;font-size:11px!important;">
                    <div class=" col-12 table-responsive-sm" style="width:100%!important;margin:0px;padding:0px;">
                        <table class="" style="width:100%!important;margin:0px;padding:0px;" border="0">
                            <tr class="rmp-all">
                                <th style="text-align: right;">
                                    <h6>Username : </h6>
                                </th>

                                <th><input type="text" style="margin:0px;padding:0px; padding-left: 8px;" [ngModel]="user_name" (ngModelChange)="user_name = $event" class="form-control form-control-sm" placeholder="Username" /></th>

                                <th style="text-align: right;">
                                    <h6>Status : </h6>
                                </th>
                                <th> <select class="form-control form-control-sm" [ngModel]="status" (ngModelChange)="status = $event">
                        <option value="0" disabled selected>Select Status</option>
                        <option [ngValue]=1>Active</option>
                        <option [ngValue]=2>Inactive</option>
                      </select>
                                </th>
                                <th style="text-align: right;">
                                    <h6>Role : </h6>
                                </th>
                                <th>
                                    <select class="form-control form-control-sm" [ngModel]="role" (ngModelChange)="role = $event">
                      <option value="0" disabled selected>Select Role</option>
                      <option [ngValue]=1>Lead User</option>
                      <option [ngValue]=2>Editor User</option>
                      <option [ngValue]=6>Read User</option>
                      <option [ngValue]=11>Owner</option>
                      <option [ngValue]=12>Consultant</option>
                      <option [ngValue]=21>Main Contact</option>
                    </select>
                                </th>

                                <th>
                                    <!--Button with tooltip and no label -->


                                    <div class="cover-x " style="display: inline-block">
                                        <div class="main-btn rounded-circle rmp-all" (click)="onSearch()" title="Apply filters..." style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
                                            <span class="fa fa-search fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
                                        </div>
                                    </div>

                                    <div class="cover-x" style="display: inline-block">
                                        <div class="main-btn rounded-circle rmp-all" (click)="onReset()" title="Reset filters..." style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
                                            <span class="fa fa-undo fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </table>
                    </div>
                </div>
            </fieldset>







            <br/>
            <br/>

            <table class="table table-sm table-striped" style="border-top:none;" id="transactions">
                <thead class="" style="background:white!important;border-top:none;">
                    <tr style="vertical-align:middle;">

                        <th scope="col">Username</th>
                        <th scope="col">Email</th>
                        <th scope="col">Mobile Number</th>
                        <th scope="col">Phone Number</th>
                        <th scope="col">Status</th>
                        <th scope="col">Role</th>
                        <th scope="col"></th>

                    </tr>
                </thead>
                <tr *ngFor="let cons of consultants | paginate: { itemsPerPage: 10, currentPage: page }">
                    <td>{{cons.username}}</td>
                    <td>{{cons.email}}</td>
                    <td>{{cons.mobile}}</td>
                    <td>{{cons.phone}}</td>
                    <td>{{cons.status}}</td>
                    <td *ngIf="cons.role == 1">Lead User</td>
                    <td *ngIf="cons.role == 2">Editor User</td>
                    <td *ngIf="cons.role == 6">Read User</td>
                    <td *ngIf="cons.role == 11">Owner</td>
                    <td *ngIf="cons.role == 12">Consultant</td>
                    <td *ngIf="cons.role == 21">Main Contact</td>

                    <td class="btn-show">
                        <select class="form-control" (change)="selectOptionList(select.value,cons)" #select>
              <option>Select</option>
              <option value="0" *ngIf="cons.status != 'Inactive' && cons.status != 'inactive'">Mark As Inactive</option>
              <option value="1">Change User Role</option>
              <option value="2" *ngIf="cons.status == 'Inactive' || cons.status == 'inactive'">Resend User OTP</option>
            </select>
                    </td>


                </tr>
                <tfoot>
                    <tr *ngIf="consultants.length > 0">
                        <td colspan="9" class="rm-brd">
                            <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;"></pagination-controls>
                        </td>
                    </tr>
                    <tr *ngIf="count === 0">
                        <td colspan="9" class="rm-brd">
                            <span class="text-info text-small">No Consultants Available for this account.</span>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>

    <div class="pull-right">
        <button class="btn cancel-btn" title="Go Back" (click)="cancel()"></button>
    </div>

    <button data-toggle="modal" data-target="#modalPopup" id="secretButton" style="display:none"></button>

    <div #thisModal class="modal fade form-group" id="modalPopup" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content bgd-c" style="border:none!important;">
                <div class="modal-body" style="border:none!important;">
                    <p class="h6" id="PopupTitle">{{title || 'Confirmation'}}</p>
                    <small class="extra-clr ft-c">{{message}}</small><br/>
                    <small class="text-small" style="font-size:10px!important">{{'Please select role you want to give user before proceeding'}}</small>
                    <select #roleServed (change)="roleChange(roleServed)" class="form-control form-control-sm" name="role" style="margin-top: 10px; margin-bottom: 5px;">
            <option value="" disabled selected>Select Role</option>
            <option *ngFor="let role of roles" [value]="role.role" >{{role.desc}}</option>
          </select>
                    <div style="border:none!important;height:20px!important;margin-top:10px!important;">
                        <button type="button" data-dismiss="modal" class="btn btn-danger btn-sm pull-right" style="margin-right:4px!important;">{{'Cancel'}}</button>
                        <button [disabled]="proceedDisabled" type="button" data-dismiss="modal" class="btn btn-primary btn-sm pull-right" style="margin-right:4px!important;padding-right:4px!important;" (click)="confirm(thisModal)">{{'Proceed'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
